import api from './api-config'
import { BookData, BookChapter, Chapter } from '../types'
import { AxiosRequestConfig } from 'axios'

export default class BookApi {
  static api = api
  static async createBook(data: Partial<BookData>): Promise<BookData> {
    return (await api.post('/book/', data)).data
  }

  static async listBooks(): Promise<BookData[]> {
    return (await api.get('/book/')).data
  }

  static async listPublishedBooks(): Promise<BookData[]> {
    return (await api.get('/book/published/')).data
  }

  static async getBook(id: string): Promise<BookData> {
    return (await api.get(`/book/${id}/`)).data
  }

  static async updateBook(id: string, data: Partial<BookData>): Promise<BookData> {
    return (await api.put(`/book/${id}/`, data)).data
  }

  static async getBookCategories(): Promise<BookData> {
    return (await api.get(`/book/categories/`)).data
  }

  static async getBookFeed(filter: string, pageNumber: number): Promise<BookData[]> {
    return (await api.get(`/book/published/discover/${filter}/${pageNumber}/`)).data
  }

  static async searchBooks(query: string, pageNumber: number): Promise<BookData[]> {
    return (await api.get(`/book/published/search/?query=${query}&pageNumber=${pageNumber}`)).data
  }

  static async getPublishedBook(id: string, configs?: AxiosRequestConfig): Promise<BookData> {
    return (await api.get(`/book/published/${id}/`, configs)).data
  }

  static async getPublishedBookChapters(id: string, configs?: AxiosRequestConfig): Promise<Chapter[]> {
    return (await api.get(`/book/published/${id}/chapters/`, configs)).data
  }

  static async getBookChapter(id: string, chapterNumber: number, configs?: AxiosRequestConfig): Promise<BookChapter> {
    return (await api.get(`/book/${id}/chapter/${chapterNumber}/`, configs)).data
  }

  static async getUserBookChapterRead(id: string, configs?: AxiosRequestConfig): Promise<{ chapterNumber: number }> {
    return (await api.get(`/book/${id}/chapter/last-read/`, configs)).data
  }

  static async logBookView(id: string): Promise<{ success: boolean }> {
    return (await api.post(`/book/published/${id}/read/`)).data
  }

  static async updateCover(id: string, file: File): Promise<any> {
    const formData = new FormData()
    formData.append('cover', file)

    return (
      await api.post(`/book/${id}/cover/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    ).data
  }

  static async listTags(): Promise<string[]> {
    return (await api.get('/book/tags/')).data
  }

  static async getBookRoulette(tags: string[]): Promise<BookData[]> {
    return (await api.post('/book/roulette/', tags)).data
  }
}
